import { Query } from "@components/molecules/Newsletter/Newsletter.hooks";

const parseData = (data: Query["strapiShared"], language: string) => {
  let heading: string;
  let description: string;

  if (language === "en") {
    heading = data.newsletterHeadingEN;
    description = data.newsletterDescriptionEN.data.newsletterDescriptionEN;
  } else if (language === "de") {
    heading = data.newsletterHeadingDE;
    description = data.newsletterDescriptionDE.data.newsletterDescriptionDE;
  } else {
    heading = data.newsletterHeading;
    description = data.newsletterDescription.data.newsletterDescription;
  }

  return {
    heading: heading.replace(/{{(.*?)}}/g, "<span>$1</span>"),
    description: description.replace("<p>", "").replace("</p>", ""),
  };
};

export { parseData };
